import { render, staticRenderFns } from "./ContractsCompanies.vue?vue&type=template&id=250488ba&"
import script from "./ContractsCompanies.vue?vue&type=script&lang=js&"
export * from "./ContractsCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports